const payOutReducer = {};
export default payOutReducer;
